"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.creditAgreementSourceDocumentMetadataKeys = exports.CreditAgreementSchemaVersion = exports.OvercollateralizationMethod = exports.AutoApprovalStrategy = exports.Items = exports.PropertyContainerType = exports.ReportConfigTypeIterable = exports.NumberPropertyUnit = exports.PropertyType = void 0;
/**
 * NOTE: Credit Agreement Interfaces will shared across multiple services/modules, as it serves as a central
 * configuration for the codebase.  In general, we don't want to export types/interfaces from FinleyTypes,
 * as they can typically be contained by the owner service/module
 */
/**
 * NOTE: This is a temporary home for portions CreditAgreement Domain Entity such that we can
 * more easily refactor concentration limit calculation.
 * Once fully migrated to PG, this should moved back to credit-agreements module
 */
var PropertyType;
(function (PropertyType) {
    PropertyType["AutoApprovalProperty"] = "autoApprovalProperty";
    PropertyType["AttachmentRateLimitProperty"] = "attachmentRateLimitProperty";
    PropertyType["BankAccountTypeProperty"] = "bankAccountTypeProperty";
    PropertyType["BooleanProperty"] = "booleanProperty";
    PropertyType["CashAdvanceRateProperty"] = "cashAdvanceRateProperty";
    PropertyType["ClassAllocationMethodProperty"] = "classAllocationMethodProperty";
    PropertyType["ClassLabelProperty"] = "classLabelProperty";
    PropertyType["CommitmentAmountConfigurationProperty"] = "commitmentAmountConfigurationProperty";
    PropertyType["ConcentrationLimitProperty"] = "concentrationLimitProperty";
    PropertyType["CurrencyProperty"] = "currencyProperty";
    PropertyType["DateProperty"] = "dateProperty";
    PropertyType["DeliverableReportProperty"] = "deliverableReportProperty";
    PropertyType["DeliverableProperty"] = "deliverableProperty";
    PropertyType["EligibilityTestProperty"] = "eligibilityTestProperty";
    PropertyType["FinancialCovenantProperty"] = "financialCovenantProperty";
    PropertyType["FrequencyPeriodProperty"] = "frequencyPeriodProperty";
    PropertyType["FrequencyProperty"] = "frequencyProperty";
    PropertyType["InterestRateBenchmarkProperty"] = "interestRateBenchmarkProperty";
    PropertyType["InterestRateConfigurationProperty"] = "interestRateConfigurationProperty";
    PropertyType["LiabilityAccountProperty"] = "liabilityAccountProperty";
    PropertyType["LinkedAccountProperty"] = "linkedAccountProperty";
    PropertyType["MaximumPrefundingAmountProperty"] = "maximumPrefundingAmountProperty";
    PropertyType["NumberProperty"] = "numberProperty";
    PropertyType["OvercollateralizationAmountProperty"] = "overcollateralizationAmountProperty";
    PropertyType["OvercollateralizationMethodProperty"] = "overcollateralizationMethodProperty";
    PropertyType["PercentageRateProperty"] = "percentageRateProperty";
    PropertyType["PortfolioCovenantProperty"] = "portfolioCovenantProperty";
    PropertyType["PurchasePercentageRateProperty"] = "purchasePercentageRateProperty";
    PropertyType["ReceivableAdvanceRateProperty"] = "receivableAdvanceRateProperty";
    PropertyType["ReceivableValuationRateProperty"] = "receivableValuationRateProperty";
    PropertyType["RecurringDateProperty"] = "recurringDateProperty";
    PropertyType["ReportProperty"] = "reportProperty";
    PropertyType["ReportTypeProperty"] = "reportTypeProperty";
    PropertyType["StructureProperty"] = "structureProperty";
    PropertyType["TextProperty"] = "textProperty";
})(PropertyType = exports.PropertyType || (exports.PropertyType = {}));
var NumberPropertyUnit;
(function (NumberPropertyUnit) {
    NumberPropertyUnit["Day"] = "day";
    NumberPropertyUnit["BusinessDay"] = "businessDay";
    NumberPropertyUnit["Hour24"] = "hour24";
    NumberPropertyUnit["Hour"] = "hour";
})(NumberPropertyUnit = exports.NumberPropertyUnit || (exports.NumberPropertyUnit = {}));
// Note: below should align with "Report.ReportType" directly.
// If enough supported reports overlap, can consider merging / utilizing single source
exports.ReportConfigTypeIterable = [
    'assetVerification',
    'borrowingBaseServicerReport',
    'borrowingBaseCertificate',
    'disbursementNotice',
    'fundingNotice',
    'fundingRequestServicerReport',
    'invoice',
    'monthlyServicerReport',
    'noticeOfBorrowing',
    'noticeOfPrepayment',
    'paymentInKindNotice',
    'receivableResponseTapePreviewServicerReport',
    'receivablesSaleAgreement',
    'releaseNotice',
];
var PropertyContainerType;
(function (PropertyContainerType) {
    PropertyContainerType["DeliverableReportPropertyContainer"] = "deliverableReportPropertyContainer";
    PropertyContainerType["LinkedAccountPropertyContainer"] = "linkedAccountPropertyContainer";
    PropertyContainerType["ReportTypePropertyContainer"] = "reportTypePropertyContainer";
    PropertyContainerType["TextPropertyContainer"] = "textPropertyContainer";
})(PropertyContainerType = exports.PropertyContainerType || (exports.PropertyContainerType = {}));
var Items;
(function (Items) {
    let PartyType;
    (function (PartyType) {
        PartyType["AdminAgent"] = "adminAgent";
        PartyType["BackupServicer"] = "backupServicer";
        PartyType["Borrower"] = "borrower";
        PartyType["CapitalProvider"] = "capitalProvider";
        PartyType["CapitalProviderRepresentative"] = "capitalProviderRepresentative";
        PartyType["CollectionAccountBank"] = "collectionAccountBank";
        PartyType["PayingAgent"] = "payingAgent";
        PartyType["Servicer"] = "servicer";
        PartyType["VerificationAgent"] = "verificationAgent";
    })(PartyType = Items.PartyType || (Items.PartyType = {}));
    let CustomerType;
    (function (CustomerType) {
        /**
         * The customer on whose behalf we have configured this facility. Most commonly this will be
         * a borrower using Finley to generate loan tapes, compute a borrowing base report, and submit
         * funding requests; or a capital provider set up for calc verification.
         *
         * This customer has the broadest set of permissions on a facility.
         */
        CustomerType["Owner"] = "owner";
        /**
         * A customer who is not an {@link Owner}, but may log in to Finley's systems. Examples: a
         * capital provider who logs in to approve o borrower Owner's funding request; or a borrower
         * who logs in to do remediation on a capital provider Owner's verification facility.
         *
         * The set of permissions allowed here is currently poorly defined, but this will become more
         * explicit over time.
         */
        CustomerType["Limited"] = "limited";
        /**
         * This party exists in the system for record-keeping, but does not log in to or interact with
         * our system directly.
         */
        CustomerType["None"] = "none";
    })(CustomerType = Items.CustomerType || (Items.CustomerType = {}));
    let InterestRateBase;
    (function (InterestRateBase) {
        InterestRateBase["Fixed"] = "fixed";
        InterestRateBase["Benchmark"] = "benchmark";
    })(InterestRateBase = Items.InterestRateBase || (Items.InterestRateBase = {}));
})(Items = exports.Items || (exports.Items = {}));
var AutoApprovalStrategy;
(function (AutoApprovalStrategy) {
    AutoApprovalStrategy["SpecificHour"] = "specificHour";
    AutoApprovalStrategy["WithDelay"] = "withDelay";
    AutoApprovalStrategy["Immediate"] = "immediate";
})(AutoApprovalStrategy = exports.AutoApprovalStrategy || (exports.AutoApprovalStrategy = {}));
var OvercollateralizationMethod;
(function (OvercollateralizationMethod) {
    OvercollateralizationMethod["ClassSubordination"] = "classSubordination";
})(OvercollateralizationMethod = exports.OvercollateralizationMethod || (exports.OvercollateralizationMethod = {}));
var CreditAgreementSchemaVersion;
(function (CreditAgreementSchemaVersion) {
    CreditAgreementSchemaVersion["1.0"] = "1.0";
})(CreditAgreementSchemaVersion = exports.CreditAgreementSchemaVersion || (exports.CreditAgreementSchemaVersion = {}));
exports.creditAgreementSourceDocumentMetadataKeys = [
    'id',
    'facilityType',
    'creditFacilityId',
    'effectiveFrom',
    'effectiveTo',
    'version',
    '_schemaVersion_',
    's3Path',
    '_note_',
    '_currentCreditAgreementId_',
];
//# sourceMappingURL=DomainEntity.js.map